import { sleep } from "../../../../library-js/animation/sleep";
import { DateFormatter } from "../../../../library-js/date/DateFormatter";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { PrettyJSON } from "../../../../library-js/text/PrettyJSON";
import { RegExpUtility } from "../../../../library-js/text/RegExpUtility";
import { EMailData } from "../../../../library/ts/node/server/mailer/EMailData";
import { CSV, CSVIndex, CSVRange } from "../../../../library/ts/vanilla/text/CSV";
import { LocalIO } from "../../../js/_internal/LocalIO";
import { MailerInfo } from "../../../js/_internal/MailerInfo";
import { RJMailer } from "../../../js/_internal/RJMailer";
import { EmailOptions } from "./EmailOption";
import { SendJob, SendJobs } from "./SendJob";

export class MailsEditor
{ 
  static readonly requests  = new ElementAttribute( "requests" );
  static readonly keys  = new ElementAttribute( "keys" );

  static readonly sendMails = new ElementAttribute( "send-mails" ); 
  static readonly infoBlock = new ElementType( "info-block" ); 
  static readonly entry = new ElementType( "entry-info" );  

  static readonly keysNumber     = new ElementType( "keys-number" );
  static readonly streamersNumber = new ElementType( "streamers-number" );

  static mailsPath = "../../source/_rokojori.com/_mails/";

  static sentPath = MailsEditor.mailsPath + "sent/";

  static keysPath = MailsEditor.mailsPath + "keys/";
  static keysAllFileName = "all-dck-keys.csv";

  static streamersPath = MailsEditor.mailsPath + "streamers/";
  static streamersAllFileName = "all-streamers-list.csv";

  static infoPath = MailsEditor.mailsPath + "mailer.json";
  static emailOptionsPath = MailsEditor.mailsPath + "email-options.json";

  static emailsPath = MailsEditor.mailsPath + "emails/";


  _keysList:CSV[] = []; 
  _streamersList:CSV[] = [];
  _keysSent = new Set<string>();

  _element:Element;
  _freeKeys:number;
  _streamers:number;

  _mailerInfo:MailerInfo;
  _sendJobs:SendJobs = new SendJobs();
  _emailOptions:EmailOptions;
  _mailer:RJMailer;

  async initialize( e:Element )
  {
    this._element = e;
    this._mailerInfo = await LocalIO.loadJSON( MailsEditor.infoPath );
    this._mailer = new RJMailer();
    this._mailer.load( this._mailerInfo );

    this._emailOptions = await LocalIO.loadJSON( MailsEditor.emailOptionsPath );

    console.log( this._mailerInfo, this._emailOptions );

    this._keysList = await this.loadAll( MailsEditor.keysPath, MailsEditor.keysAllFileName );   

    this._sendJobs.addKeys( this._keysList );

    this._streamersList = await this.loadAll( MailsEditor.streamersPath, MailsEditor.streamersAllFileName );

    this.processKeys();
    this.processStreamers();

    let sendMailsButton = MailsEditor.sendMails.query<HTMLElement>( e );

    OnClick.add( sendMailsButton, ()=> this.sendEmails() );
  }

  async sendEmails()
  {
    let infoBlock = MailsEditor.infoBlock.query( this._element );
    let sleepDuration = 1000;

    let testing = true;

    for ( let job of this._sendJobs.jobs )
    {
      if ( testing )
      {
        let keyMap = this._sendJobs.getSendingKeyMapFor( job );
        console.log( "Job", job.email, keyMap, job.reference.csv );

        if ( ! keyMap )
        {
          for ( let i = 0; i < this._sendJobs.keyMaps.length; i++ )
          {
            let km = this._sendJobs.keyMaps[ i ];
            console.log( i, km.csv === job.reference.csv, km.csv, km )
          }

          return;
        }
      }

      infoBlock.innerHTML = "";
      let infoClone = job.clone();
      infoClone.reference = null;

      let jsonInfo = PrettyJSON.stringify( infoClone );
      infoBlock.appendChild( ElementType.pre.create( jsonInfo ) );
      infoBlock.appendChild( ElementType.break.create() );

      let option = this._emailOptions.options.find( o => o.name === job.emailType );  
      let language = job.language;

      let filePath = `${option.path}/${option.path}-${language}.html`;
      let emailData = await LocalIO.loadText( MailsEditor.emailsPath + filePath);

      let div = ElementType.div.create();
      let doc = HTMLEditor.stringToDocument( emailData );

      let sendingDoc = doc.querySelector( "html" ).innerHTML;

      let replacements = new Map();
      replacements.set( "${Name}", job.name );
      replacements.set( "${Steam-Key}", job.key );

      sendingDoc = RegExpUtility.replaceAll( sendingDoc, replacements );

      div.innerHTML = sendingDoc;

      let mailData = new EMailData();
      mailData.to = job.email;
      mailData.reply = "josef@rokojori.com";
      mailData.message = sendingDoc;
      mailData.subject = doc.querySelector( "title" ).textContent;

      let timeLabel = DateFormatter.toShortWithTimeForFiles( new Date() );
      let mailFileName = RegExpUtility.escapePathFragmentForWindows( job.email ) + "_" + timeLabel + ".html";

      await LocalIO.saveJSON( MailsEditor.sentPath + mailFileName , mailData );

      await this._mailer.send( mailData );

      infoBlock.appendChild( div );

      this._sendJobs.markSent( job );

      let csv = job.reference.csv;
      
      console.log( "saving", csv.filePath, csv );
      await LocalIO.saveCSV( csv.filePath, csv );


      await sleep( sleepDuration );
      
    }

    infoBlock.innerHTML = "Sent " + this._sendJobs.jobs.length + " emails";

    
  }

  async loadAll( directorPath:string, allFileName:string ):Promise<CSV[]>
  {
    let allPaths = await LocalIO.loadCSV( directorPath + allFileName );   

    let allCSV:CSV[] = [];

    for ( let i = 0; i < allPaths.numLines; i++ )
    {
      let keyPath = directorPath + allPaths.get( i );
      let keyList = await LocalIO.loadCSV( keyPath ); 

      allCSV.push( keyList );
    }

    return allCSV;
  }

  findKey():[CSV,CSVIndex]
  {
    for ( let i = 0; i < this._keysList.length; i++ )
    {
      let keyList = this._keysList[ i ];
      let csvIndex = keyList.findEmptyInRow( 1 );

      if ( csvIndex != null )
      {
        return [ keyList, csvIndex.previousRow ];
      }

    } 

    return null;
  }


  createEmailSentHash( name:string, email:string )
  {
    return "Name:" + name + ", Email: " + email;
  }

  processKeys()
  {
    let freeKeys = 0;

    this._keysList.forEach(
      ( kl )=>
      {
        let start = CSVIndex.$( 1, 1 );
        let end   = CSVIndex.$( kl.lastLineIndex, 1 );

        let freeKeysInList = kl.countEmpty( start, end );
        freeKeys += freeKeysInList;

        kl.forAll( start, end,
          ( v, i )=>
          {
            let nameIndex = i;
            let emailIndex = nameIndex.nextRow;

            let name  = kl.getValue( nameIndex );
            let email = kl.getValue( emailIndex );

            let hash = this.createEmailSentHash( name, email );

            if ( ! this._keysSent.has( hash ) )
            {
              this._keysSent.add( hash );
            }
          }
        )

      }
    )

    this._freeKeys = freeKeys;

    let keysNumber =MailsEditor.keysNumber.query( this._element );
    keysNumber.innerHTML = this._freeKeys + "";
  }

  processStreamers()
  {
    let streamers = 0;

    let infoBlock = MailsEditor.infoBlock.query( this._element );

    this._streamersList.forEach(
      ( sl )=>
      {

        let headerName = sl.find( "Name" );
        let start = headerName.nextLine; 
        let languageRow  = sl.findRowOffset( headerName.line, "Language" );
        let emailTypeRow = sl.findRowOffset( headerName.line, "Email Type" );

        if ( start == null )
        {
          console.error( "Name was not found in:", sl );
          return;
        }

        let end   = CSVIndex.$( sl.lastLineIndex, start.row );

        streamers += ( end.line - start.line ) + 1 ;

        sl.forAll( start, end, 
          ( v, index )=>
          {
            let nameIndex = index;
            let emailIndex = nameIndex.nextRow;

            let name  = sl.getValue( nameIndex );
            let email = sl.getValue( emailIndex );

            let hash = this.createEmailSentHash( name, email );

            if ( this._keysSent.has( hash ) )
            {       
              console.log( "Won't send because already sent:", name );       
              return;
            }
            
            let emailType = sl.get( index.line, emailTypeRow );

            let emailEntry = this._emailOptions.options.find( o => o.name === emailType );

            if ( emailEntry == null )
            {
              console.log( "Won't send because of email type:", name, ">>", emailType );
              return;
            }

            let key = this._sendJobs.findKey();

            if ( key == null )
            {
              console.log( "No key found:", name, key );
              return;  
            }


            console.log( "Found key:", name, key );

            let keyCSV  =  key.csv;
            let keyIndex = key.index;

            let keyEntry = keyCSV.getValue( keyIndex.previousRow );


            let sendJob = new SendJob();
            sendJob.email = email;
            sendJob.name = name;
            sendJob.emailType = emailType;
            sendJob.language  = sl.get( index.line, languageRow );
            sendJob.key = keyEntry;
            sendJob.reference = key;


            this._sendJobs.addJob( sendJob );  


            let info = `${name} (${email}) > ${sendJob.emailType} (${sendJob.language})  ${keyEntry}`;

            let entry = ElementType.div.create( info );
            infoBlock.appendChild( entry );
         
          }
        );
      }
    )

    this._streamers = streamers;

    let streamersNumber = MailsEditor.streamersNumber.query( this._element );
    streamersNumber.innerHTML = this._streamers + "";
  }

  forAllCSV( lists:CSV[], findRange:(c:CSV)=>CSVRange, action:( v:string, i:CSVIndex)=>void )
  {
    lists.forEach(
      ( c )=>
      {
        let range = findRange( c );
        c.forAllIn( range, action );
      }
    )  
  }

  forAllStreamers( action:( v:string, i:CSVIndex)=>void )
  {
    let findRange = ( c:CSV )=>
    {
      let start = c.find( "Name" ).nextLine; 
      let end   = CSVIndex.$( c.lastNonEmptyLineIndex, start.row );
      
      return CSVRange.create( start, end );
    } 

    return this.forAllCSV( this._streamersList, findRange, action );
  }


}